import { AccessibleSite, UserModel } from "types";

function siteIdOf(site: AccessibleSite | { _id?: string } | string | undefined | null): string | undefined {
  if (!site) return undefined;
  if (typeof site === "string") return site;
  return site._id?.toString();
}

/** True if the user may edit or delete a site record in the Sites list. */
export function canEditSiteRecord(user?: UserModel | null, siteId?: string | null): boolean {
  if (!user || !siteId) return false;
  if (user.type === "super") return true;
  const id = siteId.toString();
  const site = user.sites?.find((s) => siteIdOf(s) === id);
  return site?.role === "admin";
}

export function canDeleteSiteRecord(user?: UserModel | null): boolean {
  if (!user) return false;
  return user.type === "super";
}

/** True if the user belongs to this site (any role) or is super. */
export function canAccessSite(user?: UserModel | null, siteId?: string | null): boolean {
  if (!user || !siteId) return false;
  if (user.type === "super") return true;
  const id = siteId.toString();
  return !!user.sites?.some((s) => siteIdOf(s) === id);
}

/** True if the user may mutate resources for this site (add/edit/delete/SSH/ROI). */
export function canManageSite(user?: UserModel | null, siteId?: string | null): boolean {
  return canEditSiteRecord(user, siteId);
}

/** True if the user is admin on at least one site (or super). */
export function canManageAnySite(user?: UserModel | null): boolean {
  if (!user) return false;
  if (user.type === "super") return true;
  return !!user.sites?.some((s) => s.role === "admin");
}
